import Vue from 'vue';
import Vuex from 'vuex';
import cookies from 'js-cookie';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    state() {
        return {
            isLogin: null,
            userInfo: {
                username: '',
            },
            // 判断页头背景色是否透明
            isTransparent: false,
            scrollId: '',
            feedbackShow: false,
            showRenew: {
                api: true,
                http: true,
                kafka: true,
                module: true,
                mqtt: true
            }
        };
    },
    mutations,
    actions,
    strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js